$(document).ready(function () {
  if ($(".phLab").length !== 0) {
    //------------Tutorial--------------------------------------//

    window.tour1 = [
      {
        element:
          ".phLabEditSizes:visible .phLabEditSize:first-child .phLabEditSizeCountPlus",
        text: "Select Size:<br>Here you can select sizes and quantity<br>",
      },
      {
        element: "#phLabEditPortrait",
        text: "Select Orientation : <br> Here you can select orientation of image such as vertical , horizontal , square and panaroma. <br>",
      },
      {
        element: ".phLabEditTypes .phLabEditType:visible",
        text: "Print Type : <br> Here you can select print type . you can select print on photopaper , canvas and metal. <br>",
      },
      {
        element: ".phLabEditAddToQueue2Con",
        text: "Add to queue : <br> After select images and sizes you must click on this button to finalize your order and add to your cart .",
      },
    ];
    window.tour2 = [
      {
        element: ".phLabEditAreaCntZoom",
        text: "Image Zoom : <br> Here you can zoom your image by pushing the blue circle. <br>",
      },
      {
        element: "#phLabEditFilters",
        text: "tips",
      },
      {
        element: "#phLabEditAdjust",
        text: "tips",
      },
    ];

    function plSetCookie(c_name, value, exdays) {
      var exdate = new Date();
      exdate.setDate(exdate.getDate() + exdays);
      var c_value =
        escape(value) +
        (exdays == null ? "" : "; expires=" + exdate.toUTCString());
      document.cookie = c_name + "=" + c_value;
    }

    function plGetCookie(c_name) {
      var c_value = document.cookie;
      var c_start = c_value.indexOf(" " + c_name + "=");
      if (c_start == -1) {
        c_start = c_value.indexOf(c_name + "=");
      }
      if (c_start == -1) {
        c_value = null;
      } else {
        c_start = c_value.indexOf("=", c_start) + 1;
        var c_end = c_value.indexOf(";", c_start);
        if (c_end == -1) {
          c_end = c_value.length;
        }
        c_value = unescape(c_value.substring(c_start, c_end));
      }
      return c_value;
    }

    function plShowTour(target) {
      let prefix = "photoLab-Tour";
      if (plType === "metal") prefix = "metalPrint-Tour";
      if (!(plGetCookie(prefix + target) === "yes")) {
        //plSetCookie(prefix+target, "yes", 365);
        // TourStart(window["tour" + target]);
      } else {
        // TourStart(window["tour" + target]);
      }
    }

    //------------End Tutorial--------------------------------------//

    $("#input_7_1").attr("value", $("#np").text());
    $("#input_7_3").attr("value", $("#soa").text());
    $("#input_7_9").attr("value", $("#poa").text());
    $(".postid-4606 .nbo-base-price-html").text("Total Price");
    $(".postid-4606 .ginput_total").text($("#poa").text());
    $("#input_7_5").val($("#poa").text());
    if (!$("#poa").text() == "") {
      $(".postid-4606 .summary .product-price .woocommerce-Price-amount").text(
        $("#poa").text()
      );
    }

    //filestack

    // filestackCallback = plAddImageToList;
    // $(".phLabUploadArea,.phLabEditUploadArea").click(function () {
    //     filestackShow();
    // });

    // $("body").on("click",".filestakQueryLocal",function () {
    //     $("#phLabAddImageByClick").get(0).click();
    //     $(".filestakQuery").hide();
    // });

    // $("body").on("click",".filestakQueryCloud",function () {
    //     $(".filestakQuery").hide();
    //     filestackClient.picker(filestackPickerOption).open();
    // });

    // $("body").on("click",".filestakClose",function(){
    //     $(".filestakQuery").hide();
    // });

    //global

    let selectAllApplyTo = false;
    let plImageId = 1;
    let plCropId = 1;
    let plSelImg = {
      src: "",
      id: "",
      alt: "",
      width: 0,
      height: 0,
    };
    let plSelCrop = "";
    // let plImages = [];
    let plSizes = [];
    let plCrops = [];
    let plZoomMin = undefined;
    const plZoomMax = 1;
    let plZoomCount = 1;
    let plCurAng = 0;
    let plCurOri = 0;

    let plMarginCanvas = [];
    let plMarginCanvasCtx = [];
    let plMarginCanvas2 = [];
    let plMarginCanvasCtx2 = [];
    let plCanvasMarginWidth = 20;
    let plCanvasMarginWidth2 = 20;

    const url = new URL(window.location.href);
    let plType = url.searchParams.get("type");
    let plAction = url.searchParams.get("action");

    var isMetal = false;
    var isFoam = false;
    var isCanvas = false;


    //start

    if ($(".phLab").length !== 0) {
      plSetImageAddress();
      plGetData(function () {
        if (plAction === "FastOpen") $("#phLabAddImageByClick").get(0).click();
      });
      plSetSizes();
      plChangeEditTab();
      plCheckAllCropList();
      plDefineCanvasMargin();
    }

    //fabric

    let fabricCanvas = new fabric.Canvas("phLabCanvas");
    fabricCanvas.set({
      uniScaleTransform: false,
      enableRetinaScaling: true,
      uniScaleKey: "none",
      selection: false,
      containerClass: "phLabCanvas",
      controlsAboveOverlay: true,
      backgroundColor: "#fff",
    });
    fabricCanvas.textureSize = 4096;

    //functions

    fpCheckQueryInput();

    function fpCheckQueryInput() {
      const url = new URL(window.location.href);
      var imgSrc = url.searchParams.get("imgSrc");
      var last = url.href.split("/");
      last = last[last.length - 1];

      $("#phLabEditLoading").show();

      if (imgSrc != null) {
        plAddImageFromUrl(imgSrc);
      } else {
        $("#phLabEditLoading").hide();
      }

      if (last.startsWith("MetalPrint") || last.startsWith("metal-prints")) {
        $("#canvas").hide();
        $("#photoPaper").hide();
        $("#foam").hide();
        $("#metalStart").css("display", "flex");
        isMetal = true;

        $(".phLabEditTypes").find("#metal").click();
      } 
      else if(last.startsWith("FoamPrints") || last.startsWith("foam-board")){
        $("#canvas").hide();
        $("#photoPaper").hide();
        $("#metal").hide();
        $("#foamStart").css("display", "flex");
        isFoam = true;
      }
      else {
        $("#photoStart").css("display", "flex");
        $("#foam").hide();
      }
    }

    function plAddImageFromUrl(url) {
      if (url.includes("|||")) {
        url = url.split("|||");
        url.splice(-1);

        loadCount = 0;

        url.forEach(function (u) {
          var image = new Image();
          image.crossOrigin = 'anonymous';
          image.src = u;
          image.onload = function () {
            let id = plImageId++;

            $(".phLabImageListItems").append(
              "<div class='phLanImageListItem'>" +
                "<div class='phLanImageListItemImg' id='image" +
                id +
                "'>" +
                "<img class='phLabCenter' src='" +
                image.src +
                "'/>" +
                "</div>" +
                "<div class='phLabImageRemove'>remove</div>" +
                "</div>"
            );

            plCheckImageListVisibility();
            plUpdateEditorImgList();

            $(".phLabImageListItems").find("#image1").click();

          };
          $(".phLabEditUploadArea").hide();
          $(".phLabEditSelection").hide();
          $(".phLabUploadArea").hide();
          $(".phLabEditMainLeftArrow").hide();

          $("#phLabEditLoading").hide();
        });
      } else {
        var image = new Image();
        image.crossOrigin = 'anonymous';
        image.src = url;
        image.onload = function () {
          let id = plImageId;

          $(".phLabImageListItems").append(
            "<div class='phLanImageListItem'>" +
              "<div class='phLanImageListItemImg' id='image" +
              id +
              "'>" +
              "<img class='phLabCenter' src='" +
              image.src +
              "'/>" +
              "</div>" +
              "<div class='phLabImageRemove'>remove</div>" +
              "</div>"
          );

          plCheckImageListVisibility();

          $(".phLabImageListItems").find("#image1").click();

          $(".phLabEditUploadArea").hide();
          $(".phLabEditSelection").hide();
          $(".phLabUploadArea").hide();
          $(".phLabEditMainLeftArrow").hide();
        
          $("#phLabEditLoading").hide();
        };
      }
    }

    function plDefineCanvasMargin() {
      plMarginCanvas[0] = document.getElementById("phLabCanvasTop");
      plMarginCanvas[1] = document.getElementById("phLabCanvasRight");
      plMarginCanvas[2] = document.getElementById("phLabCanvasBottom");
      plMarginCanvas[3] = document.getElementById("phLabCanvasLeft");

      plMarginCanvas[0].height = plCanvasMarginWidth2;
      plMarginCanvas[2].height = plCanvasMarginWidth2;
      plMarginCanvas[1].width = plCanvasMarginWidth2;
      plMarginCanvas[3].width = plCanvasMarginWidth2;

      plMarginCanvasCtx[0] = plMarginCanvas[0].getContext("2d");
      plMarginCanvasCtx[1] = plMarginCanvas[1].getContext("2d");
      plMarginCanvasCtx[2] = plMarginCanvas[2].getContext("2d");
      plMarginCanvasCtx[3] = plMarginCanvas[3].getContext("2d");

      /////////////2

      plMarginCanvas2[0] = document.getElementById("phLabCanvasTop2");
      plMarginCanvas2[1] = document.getElementById("phLabCanvasRight2");
      plMarginCanvas2[2] = document.getElementById("phLabCanvasBottom2");
      plMarginCanvas2[3] = document.getElementById("phLabCanvasLeft2");

      plMarginCanvas2[0].height = plCanvasMarginWidth2;
      plMarginCanvas2[2].height = plCanvasMarginWidth2;
      plMarginCanvas2[1].width = plCanvasMarginWidth2;
      plMarginCanvas2[3].width = plCanvasMarginWidth2;

      plMarginCanvasCtx2[0] = plMarginCanvas2[0].getContext("2d");
      plMarginCanvasCtx2[1] = plMarginCanvas2[1].getContext("2d");
      plMarginCanvasCtx2[2] = plMarginCanvas2[2].getContext("2d");
      plMarginCanvasCtx2[3] = plMarginCanvas2[3].getContext("2d");
    }

    function plCanvasMargin() {
      $(".phLabCanvasCon").removeClass("phLabCanvasConHasMargin");
      $(".phLabCanvasCon").children(".phLabCanvasMargin").hide();
      $(".phLabNoSizeImg").children(".phLabCanvasMargin").hide();

      if (plSelCrop.type === "Canvas") {
        $(".phLabCanvasCon").addClass("phLabCanvasConHasMargin");
        $(".phLabCanvasCon").children(".phLabCanvasMargin").show();

        plMarginCanvas[0].width = fabricCanvas.width;
        plMarginCanvas[2].width = fabricCanvas.width;
        plMarginCanvas[1].height = fabricCanvas.height;
        plMarginCanvas[3].height = fabricCanvas.height;

        let cropImage = new Image();
        cropImage.crossOrigin = 'anonymous';
        cropImage.src = fabricCanvas.toDataURL();
        cropImage.onload = function () {
          let width = cropImage.width;
          let heigth = cropImage.height;
          plMarginCanvasCtx[0].translate(0, heigth);
          plMarginCanvasCtx[0].scale(1, -1);
          plMarginCanvasCtx[0].drawImage(
            cropImage,
            0,
            heigth - plCanvasMarginWidth
          );

          plMarginCanvasCtx[1].translate(width, 0);
          plMarginCanvasCtx[1].scale(-1, 1);
          plMarginCanvasCtx[1].drawImage(cropImage, 0, 0);

          plMarginCanvasCtx[2].translate(0, heigth);
          plMarginCanvasCtx[2].scale(1, -1);
          plMarginCanvasCtx[2].drawImage(cropImage, 0, 0);

          plMarginCanvasCtx[3].translate(width, 0);
          plMarginCanvasCtx[3].scale(-1, 1);
          plMarginCanvasCtx[3].drawImage(
            cropImage,
            width - plCanvasMarginWidth,
            0
          );
        };
      } else if (
        $(".phLabEditTypes").find(".phLabEditTypeActive").attr("id") ===
        "canvas"
      ) {
        let image = $(".phLabNoSizeImg").find("img");

        $(".phLabNoSizeImg").children(".phLabCanvasMargin").show();

        plMarginCanvas2[0].width = $(image).width();
        plMarginCanvas2[2].width = $(image).width();
        plMarginCanvas2[1].height = $(image).height();
        plMarginCanvas2[3].height = $(image).height();

        let cropImage = new Image();
        cropImage.crossOrigin = 'anonymous';
        cropImage.src = $(image).attr("src");
        cropImage.onload = function () {
          let width = cropImage.width;
          let heigth = cropImage.height;

          let scale = $(image).width() / cropImage.width;

          plMarginCanvasCtx2[0].translate(0, heigth);
          plMarginCanvasCtx2[0].scale(scale, -1);
          plMarginCanvasCtx2[0].drawImage(
            cropImage,
            0,
            heigth - plCanvasMarginWidth2
          );

          plMarginCanvasCtx2[1].translate(width, 0);
          plMarginCanvasCtx2[1].scale(-1, scale);
          plMarginCanvasCtx2[1].drawImage(cropImage, 0, 0);

          plMarginCanvasCtx2[2].translate(0, heigth);
          plMarginCanvasCtx2[2].scale(scale, -1);
          plMarginCanvasCtx2[2].drawImage(cropImage, 0, 0);

          plMarginCanvasCtx2[3].translate(width, 0);
          plMarginCanvasCtx2[3].scale(-1, scale);
          plMarginCanvasCtx2[3].drawImage(
            cropImage,
            width - plCanvasMarginWidth2,
            0
          );
        };
      }
    }

    function plSetImageAddress() {
      let dir = $(".phLab-imageDir").html();
      let list = $(".phLab").find("img");
      for (let i = 0; i < list.length; i++)
        $(list[i]).attr(
          "src",
          $(list[i]).attr("src").replace("directory", dir)
        );
    }

    let imgInstance = new fabric.Image();

    function plChangeCropImage(callBack = function () {}) {
      if (callBack === {}) $("#phLabEditLoading").show();
      plResetOptions();
      if (fabricCanvas._objects[0]) {
        fabricCanvas.remove(fabricCanvas._objects[0]);
        fabricCanvas.renderAll();
      }

      plCurOri = 0;

      let imgElement = new Image();
      imgElement.crossOrigin = 'anonymous';
      imgElement.src = plSelImg.src;
      imgElement.onload = function () {
        let imgInstance = new fabric.Image(imgElement, {
          left: 0,
          top: 0,
          opacity: 1,
          hasRotatingPoint: false,
          transparentCorners: false,
          hasControls: false,
          centeredRotation: true,
        });
        fabricCanvas.add(imgInstance);
        plFabricChangeRatio(plGetRatio(plSelCrop.size));
        plFabricFitImage();
        fabricCanvas.renderAll();

        let obj = fabricCanvas._objects[0];
        plSelImg.width = obj.width;
        plSelImg.height = obj.height;

        // auto rotate
        // if ((obj.width - obj.height > 0 && fabricCanvas.width - fabricCanvas.height < 0) ||
        //     (obj.width - obj.height < 0 && fabricCanvas.width - fabricCanvas.height > 0)) {
        //     plFabricRotate();
        // }

        setTimeout(function () {
          plCanvasMargin();
        }, 100);

        plFabricSaveImg();
        plCheckImageCropList();

        callBack();
        if (callBack === {}) $("#phLabEditLoading").hide();
      };
    }

    function plFabricRotate() {
      if (plCurOri === 0) {
        plFabricChangeRatio(plGetRatioRev(plSelCrop.size));
        plCurOri = 1;
      } else {
        plFabricChangeRatio(plGetRatio(plSelCrop.size));
        plCurOri = 0;
      }
      plFabricFitImage();
      fabricCanvas.renderAll();
      plCanvasMargin();
    }

    function plFabricPreventMovingOverflow(options) {
      if (!options.target) return;

      let tgHeight = plGetHeight(options.target);
      let tgWidth = plGetWidth(options.target);
      let tgTop = plGetTop(options.target);
      let tgLeft = plGetLeft(options.target);
      let tgBottom = tgHeight + tgTop;
      let tgRight = tgWidth + tgLeft;
      if (tgLeft > 0) {
        plSetLeft(options.target, 0);
      }
      if (tgTop > 0) {
        plSetTop(options.target, 0);
      }
      if (tgRight < fabricCanvas.getWidth()) {
        plSetLeft(options.target, fabricCanvas.getWidth() - tgWidth);
      }
      if (tgBottom < fabricCanvas.getHeight()) {
        plSetTop(options.target, fabricCanvas.getHeight() - tgHeight);
      }
    }

    function plFabricZoom(zoomVal) {
      let zoomCount = (zoomVal / 100) * plZoomMax + 1;
      plZoomCount = zoomCount;
      let imageObj = fabricCanvas._objects[0];
      imageObj.scaleX = plZoomMin * zoomCount;
      imageObj.scaleY = plZoomMin * zoomCount;
      fabricCanvas.renderAll();
      let tgHeight = plGetHeight(imageObj);
      let tgWidth = plGetWidth(imageObj);
      let tgTop = plGetTop(imageObj);
      let tgLeft = plGetLeft(imageObj);
      let tgBottom = tgHeight + tgTop;
      let tgRight = tgWidth + tgLeft;
      if (tgLeft > 0) {
        plSetLeft(imageObj, 0);
      }
      if (tgTop > 0) {
        plSetTop(imageObj, 0);
      }
      if (tgRight < fabricCanvas.getWidth()) {
        plSetLeft(imageObj, fabricCanvas.getWidth() - tgWidth);
      }
      if (tgBottom < fabricCanvas.getHeight()) {
        plSetTop(imageObj, fabricCanvas.getHeight() - tgHeight);
      }
      fabricCanvas.renderAll();
    }

    function plFabricFitImage() {
      $("#phLabEditAreaCntZoom").val(0);
      if (plZoomMin !== undefined) plFabricZoom(0);
      let imgInstance = fabricCanvas._objects[0];
      let imgRatio = plGetWidth(imgInstance) / plGetHeight(imgInstance);
      let imgWidth = plGetWidth(imgInstance);
      let imgHeight = plGetHeight(imgInstance);
      let trgRatio = fabricCanvas.getWidth() / fabricCanvas.getHeight();
      let trgWidth = fabricCanvas.getWidth();
      let trgHeight = fabricCanvas.getHeight();
      if (imgRatio <= trgRatio) {
        plSetWidth(imgInstance, trgWidth);
        plSetTop(
          imgInstance,
          -((imgHeight * (trgWidth / imgWidth) - trgHeight) / 2)
        );
        plSetLeft(imgInstance, 0);
      } else {
        plSetHeight(imgInstance, trgHeight);
        plSetLeft(
          imgInstance,
          -((imgWidth * (trgHeight / imgHeight) - trgWidth) / 2)
        );
        plSetTop(imgInstance, 0);
      }
      plZoomMin = imgInstance.scaleX;
    }

    function plFabricChangeRatio(ratio) {
      let max = 400;
      let height = max;
      let width = height * ratio;
      if (width > max) {
        width = max;
        fabricCanvas.setWidth(width).setHeight(width / ratio);
      } else fabricCanvas.setWidth(width).setHeight(height);
    }

    function plGetLeft(obj) {
      if (plCurAng === 0 || plCurAng === 270) return obj.left;
      else if (plCurAng === 90 || plCurAng === 180)
        return obj.left - getWidth(obj);
    }

    function plSetLeft(obj, val) {
      if (plCurAng === 0 || plCurAng === 270) obj.left = val;
      else if (plCurAng === 90 || plCurAng === 180)
        obj.left = val + getWidth(obj);
      fabricCanvas.renderAll();
    }

    function plGetTop(obj) {
      if (plCurAng === 0 || plCurAng === 90) return obj.top;
      else if (plCurAng === 180 || plCurAng === 270)
        return obj.top - getHeight(obj);
    }

    function plSetTop(obj, val) {
      if (plCurAng === 0 || plCurAng === 90) obj.top = val;
      else if (plCurAng === 180 || plCurAng === 270)
        obj.top = val + getHeight(obj);
    }

    function plGetWidth(obj) {
      if (plCurAng === 0 || plCurAng === 180) return obj.getScaledWidth();
      else if (plCurAng === 90 || plCurAng === 270)
        return obj.getScaledHeight();
    }

    function plGetHeight(obj) {
      if (plCurAng === 0 || plCurAng === 180) return obj.getScaledHeight();
      else if (plCurAng === 90 || plCurAng === 270) return obj.getScaledWidth();
    }

    function plSetWidth(obj, val) {
      let scaleX = 1;
      if (plCurAng === 0 || plCurAng === 180) scaleX = val / obj.width;
      else if (plCurAng === 90 || plCurAng === 270) scaleX = val / obj.height;
      obj.scaleX = scaleX;
      obj.scaleY = scaleX;
    }

    function plSetHeight(obj, val) {
      let scaleX = 1;
      if (plCurAng === 0 || plCurAng === 180) scaleX = val / obj.height;
      else if (plCurAng === 90 || plCurAng === 270) scaleX = val / obj.width;
      obj.scaleX = scaleX;
      obj.scaleY = scaleX;
    }

    function plGetRatio(size) {
      size = size.split("-");
      return size[0] / size[1];
    }

    function plGetRatioRev(size) {
      size = size.split("-");
      return size[1] / size[0];
    }

    function plGetData(callback = function () {}) {
      let ppTypes = $(".phLabData .phLab-photoPaperTypes").children();
      let ppList = $(".phLabData .phLab-photoPaper").children();
      let sizeId = 1;
      for (let i = 0; i < ppList.length; i++) {
        for (let j = 0; j < ppTypes.length; j++) {
          plSizes.push({
            id: "size" + sizeId++,
            type: "Photo Paper",
            printType: $(ppTypes[j]).html(),
            size: $(ppList[i]).html(),
            price: $(ppList[i]).attr("data-price"),
            dataType: $(ppList[i]).attr("data-type"),
          });
        }
      }
      let canvasList = $(".phLabData .phLab-canvas").children();
      for (let i = 0; i < canvasList.length; i++) {
        plSizes.push({
          id: "size" + sizeId++,
          type: "Canvas",
          printType: "",
          size: $(canvasList[i]).html(),
          price: $(canvasList[i]).attr("data-price"),
          dataType: $(canvasList[i]).attr("data-type"),
        });
      }
      let metalList = $(".phLabData .phLab-metal").children();
      for (let i = 0; i < metalList.length; i++) {
        plSizes.push({
          id: "size" + sizeId++,
          type: "Metal",
          printType: "",
          size: $(metalList[i]).html(),
          price: $(metalList[i]).attr("data-price"),
          dataType: $(metalList[i]).attr("data-type"),
        });
      }
      let foamList = $(".phLabData .phLab-foam").children();
      for (let i = 0; i < foamList.length; i++) {
        plSizes.push({
          id: "size" + sizeId++,
          type: "Foam",
          printType: "",
          size: $(foamList[i]).html(),
          price: $(foamList[i]).attr("data-price"),
          dataType: $(foamList[i]).attr("data-type"),
        });
      }
      callback();
    }

    function plGetSize(str) {
      let size = str.split("-");
      size = size[0] + "×" + size[1] + '"';
      return size;
    }

    function plSetSizes(ori = "all") {
      if ($("#photoPaperSizes").length !== 0) {
        // phLabPhotoPaperTypes
        let ppTypes = $(".phLabData .phLab-photoPaperTypes").children();
        for (let i = 0; i < ppTypes.length; i++) {
          $("#phLabPhotoPaperTypes").append(
            "" +
              "<option value='" +
              $(ppTypes[i]).html() +
              "'>" +
              $(ppTypes[i]).html() +
              "</option>"
          );
        }
        let photoPaperSizes = plSizes.filter(
          (item) => item.type === "Photo Paper"
        );
        $("#photoPaperSizes").children().remove();
        for (let i = 0; i < photoPaperSizes.length; i++) {
          if (plGetSizeOri(photoPaperSizes[i].size) !== ori)
            if (ori !== "all") continue;

          if (ori === "Panorama" && photoPaperSizes[i].dataType !== ori)
            continue;

          let size = plGetSize(photoPaperSizes[i].size);

          $("#photoPaperSizes").append(
            "" +
              "<div class='phLabEditSize clearBoth' id='" +
              photoPaperSizes[i].id +
              "'>" +
              "<div class='phLabEditSizeDesc'>" +
              "<div><b>" +
              size +
              "</b></div>" +
              "<div class='phLabEditSizeDescType'>" +
              photoPaperSizes[i].printType +
              "</div>" +
              "</div>" +
              "<div class='phLabEditSizePrice'>$" +
              photoPaperSizes[i].price +
              "</div>" +
              "<div class='phLabEditSizeCount'>" +
              "<div class='phLabEditSizeCountMines'>" +
              "<div>-</div>" +
              "</div>" +
              "<div class='phLabEditSizeCountValue'>0</div>" +
              "<div class='phLabEditSizeCountPlus'>" +
              "<div>+</div>" +
              "</div>" +
              "</div>" +
              "</div>"
          );
        }
      }
      if ($("#canvasSizes").length !== 0) {
        let canvasSizes = plSizes.filter((item) => item.type === "Canvas");
        $("#canvasSizes").children().remove();
        for (let i = 0; i < canvasSizes.length; i++) {
          if (plGetSizeOri(canvasSizes[i].size) !== ori)
            if (ori !== "all") continue;

          let size = canvasSizes[i].size.split("-");
          size = size[0] + "×" + size[1] + '"';
          $("#canvasSizes").append(
            "" +
              "<div class='phLabEditSize clearBoth' id='" +
              canvasSizes[i].id +
              "'>" +
              "<div class='phLabEditSizeDesc phLabEditSizeDescSingle'>" +
              "<div><b>" +
              size +
              "</b></div>" +
              "</div>" +
              "<div class='phLabEditSizePrice'>$" +
              canvasSizes[i].price +
              "</div>" +
              "<div class='phLabEditSizeCount'>" +
              "<div class='phLabEditSizeCountMines'>" +
              "<div>-</div>" +
              "</div>" +
              "<div class='phLabEditSizeCountValue'>0</div>" +
              "<div class='phLabEditSizeCountPlus'>" +
              "<div>+</div>" +
              "</div>" +
              "</div>" +
              "</div>"
          );
        }
      }
      if ($("#metalSizes").length !== 0) {
        let metalSizes = plSizes.filter((item) => item.type === "Metal");
        $("#metalSizes").children().remove();
        for (let i = 0; i < metalSizes.length; i++) {
          if (plGetSizeOri(metalSizes[i].size) !== ori)
            if (ori !== "all") continue;

          let size = metalSizes[i].size.split("-");
          size = size[0] + "×" + size[1] + '"';
          $("#metalSizes").append(
            "" +
              "<div class='phLabEditSize clearBoth' id='" +
              metalSizes[i].id +
              "'>" +
              "<div class='phLabEditSizeDesc phLabEditSizeDescSingle'>" +
              "<div><b>" +
              size +
              "</b></div>" +
              "</div>" +
              "<div class='phLabEditSizePrice'>$" +
              metalSizes[i].price +
              "</div>" +
              "<div class='phLabEditSizeCount'>" +
              "<div class='phLabEditSizeCountMines'>" +
              "<div>-</div>" +
              "</div>" +
              "<div class='phLabEditSizeCountValue'>0</div>" +
              "<div class='phLabEditSizeCountPlus'>" +
              "<div>+</div>" +
              "</div>" +
              "</div>" +
              "</div>"
          );
        }
      }
      if ($("#foamSizes").length !== 0) {
        let foamSizes = plSizes.filter((item) => item.type === "Foam");
        $("#foamSizes").children().remove();
        for (let i = 0; i < foamSizes.length; i++) {
          if (plGetSizeOri(foamSizes[i].size) !== ori)
            if (ori !== "all") continue;

          let size = foamSizes[i].size.split("-");
          size = size[0] + "×" + size[1] + '"';
          $("#foamSizes").append(
            "" +
              "<div class='phLabEditSize clearBoth' id='" +
              foamSizes[i].id +
              "'>" +
              "<div class='phLabEditSizeDesc phLabEditSizeDescSingle'>" +
              "<div><b>" +
              size +
              "</b></div>" +
              "</div>" +
              "<div class='phLabEditSizePrice'>$" +
              foamSizes[i].price +
              "</div>" +
              "<div class='phLabEditSizeCount'>" +
              "<div class='phLabEditSizeCountMines'>" +
              "<div>-</div>" +
              "</div>" +
              "<div class='phLabEditSizeCountValue'>0</div>" +
              "<div class='phLabEditSizeCountPlus'>" +
              "<div>+</div>" +
              "</div>" +
              "</div>" +
              "</div>"
          );
        }
      }

      plUpdateSizeCounts();
    }

    function plAddImageToList(fileList) {
      let count = 0;
      let firstId = null;
      plAddImages(fileList[count]);

      function plAddImages(cFile) {
        if (count >= fileList.length) {
          $("#phLabAddImageByClick").val("");
          $("#phLabLoading").hide();
          if (firstId !== null)
            $(".phLabImageListItems")
              .find("#" + firstId)
              .click();
          return;
        }
        if (!cFile.type.match("image")) {
          alert(cFile.name + " is not image file");
          $("#phLabLoading").hide();
          return;
        }
        let picReader = new FileReader();
        picReader.onload = function () {
          let id = plImageId++;

          if (firstId === null) firstId = "image" + id;

          $(".phLabImageListItems").append(
            "<div class='phLanImageListItem'>" +
              "<div class='phLanImageListItemImg' id='image" +
              id +
              "'>" +
              "<img class='phLabCenter' src='" +
              picReader.result +
              "' alt='" +
              cFile.name +
              "'/>" +
              "</div>" +
              "<div class='phLabImageRemove'>remove</div>" +
              "</div>"
          );
          // plImages.push({
          //     id: "image" + id,
          //     src: picReader.result,
          //     alt: cFile.name
          // });
          plCheckImageListVisibility();
          count++;
          plAddImages(fileList[count]);
        };
        picReader.onerorr = function () {
          alert("Can't read this file : " + cFile.name);
          count++;
          plAddImages(fileList[count]);
        };
        picReader.readAsDataURL(cFile);
      }
    }

    function plCheckImageListVisibility() {
      if ($(".phLabImageListItems").children().length === 0) {
        $(".phLabImageList").hide();
        $(".phLabNoImg").show();
        $(".phLab").hide();
        $("#photoPrintsBannerCover,#photoStart,#metalStart,#foamStart").show();

        // $(".phLabLeft").addClass("phLabCenter");
      } else {
        $(".phLabImageList").show();
        $(".phLabNoImg").hide();
        $(".phLab").show();

        $("#photoPrintsBannerCover,#photoStart,#metalStart,#foamStart,.sh-tab-wise-img-2-section").hide();
        // $(".phLabLeft").removeClass("phLabCenter");

        if(isMetal){ $(".phLabEditTypes").find("#metal").click(); }
        if(isFoam){ $(".phLabEditTypes").find("#foam").click(); }
      }
    }

    function plChangeCount(element) {
      let className = $(element).attr("class");
      let trg = $(element).parent();
      if (className === "phLabEditSizeCountPlus") {
        let ctn = parseInt($(trg).find(".phLabEditSizeCountValue").html()) + 1;
        $(trg).find(".phLabEditSizeCountValue").html(ctn);
      } else if (className === "phLabEditSizeCountMines") {
        let ctn = parseInt($(trg).find(".phLabEditSizeCountValue").html()) - 1;
        if (ctn >= 0) $(trg).find(".phLabEditSizeCountValue").html(ctn);
      } else if (className === "phLabEditSize clearBoth") {
        let ctn = parseInt($(element).find(".phLabEditSizeCountValue").html());
        if (ctn === 0) $(element).find(".phLabEditSizeCountValue").html("1");
      }
    }

    function plChangeEditTab(element = null) {
      if (element === null) {
        $(".phLabEditRight").find(".phLabEditSizes").hide();
        let type = $(".phLabEditTypes").find(".phLabEditTypeActive").attr("id");
        $("#" + type + "Sizes").show();
        plCheckSelectState();
      } else {
        if (!$(element).hasClass("phLabEditTypeActive")) {
          $(".phLabEditRight").find(".phLabEditSizes").hide();
          $(".phLabEditTypes")
            .find(".phLabEditTypeActive")
            .removeClass("phLabEditTypeActive");
          $(element).addClass("phLabEditTypeActive");
          let type = $(element).attr("id");
          $("#" + type + "Sizes").show();
          plCheckSelectState();
        }
      }

      plNoSizeSelect();
    }

    function plCheckSelectState() {
      let type = $(".phLabEditTypes").find(".phLabEditTypeActive").attr("id");
      if (type === "photoPaper") {
        $(".phLabEditSelect").show();
        let sizeList = $("#photoPaperSizes").find(".phLabEditSizeDescType");
        for (let i = 0; i < sizeList.length; i++) {
          if ($(sizeList[i]).html() === $("#phLabPhotoPaperTypes").val())
            $(sizeList[i]).parent().parent().show();
          else $(sizeList[i]).parent().parent().hide();
        }
      } else $(".phLabEditSelect").hide();
    }

    function plOpenEditor(element) {
      plChangeEditorImage(element);
      plUpdateEditorImgList();
      // $("body").css("overflow", "hidden");
      $(".phLabLeft").hide();
      $(".phLabRight").hide();
      $(".phLabEdit").show();
      setTimeout(() => {
        plShowTour(1);
      }, 500);
    }

    function plCloseEditor() {
      plSelCrop = "";
      // $("body").css("overflow", "auto");
      $(".phLabLeft").show();
      $(".phLabRight").show();
      $(".phLabEdit").hide();
      plCheckAllCropList();
    }

    function plUpdateSizeCounts() {
      $(".phLabEditRight").find(".phLabEditSizeCountValue").html("0");
      let imageCrops = plCrops.filter((item) => item.imageId === plSelImg.id);

      for (let i = 0; i < imageCrops.length; i++) {
        let trg = $(".phLabEditRight").find("#" + imageCrops[i].sizeId);
        $(trg).find(".phLabEditSizeCountValue").html(imageCrops[i].count);
        console.log("Test");
      }
    }

    function plChangeEditorImage(element, ori = "auto") {
      var image = new Image();
      image.crossOrigin = 'anonymous';
      image.src = $(element).find("img").attr("src");
      image.onload = function(){
        plSelImg.id = $(element).attr("id");
        plSelImg.src = image.src;
        plSelImg.alt = $(element).find("img").attr("alt");
        plSelImg.width = image.width;
        plSelImg.height = image.height;

        /*if(plType !== null)
              {
                  $(".phLabEditTypes").find("#" + plType).click();
                  if(plType === "metal")
                  {
                      $("#canvas").hide();
                      $("#photoPaper").hide();
                  }
              }*/

        if(isMetal){ plChangeEditTab($(".phLabEditTypes").find("#metal")); }
        if(isFoam){ $(".phLabEditTypes").find("#foam").click(); }

        plResetOptions();
        plCheckImageCropList();
        plUpdateSizeCounts();
        plNoSizeSelect(ori);
      }
    }

    function plNoSizeSelect(ori = "auto") {
      $(".phLabEditCon").animate(
        {
          scrollTop: 0,
        },
        100
      );

      let trg = $(".phLabNoSize").find("img");
      let image = new Image();
      image.crossOrigin = 'anonymous';
      image.src = plSelImg.src;
      image.onload = function () {
        $(trg).attr("src", image.src);
        $(trg).attr("alt", plSelImg.alt);
        plOriUpdate(ori);
      };
      $(".phLabEditAreaCntTitle").html("Select a size");
      $(".phLabNoSize").show();
      $(".phLabCanvasCon").hide();
      $(".phLabEditAreaTitle").hide();
      $(".phLabEditAreaCntZoom").hide();
      let ctnBtn = $(".phLabEditAreaCntBtn").children();
      $(ctnBtn[4]).hide();
      $(ctnBtn[5]).hide();
      $(ctnBtn[6]).hide();

      plCanvasMargin();
    }

    function plUpdateEditorImgList() {
      let imgList = $(".phLabImageListItems").children();
      $(".phLabEditImageList").html("");
      for (let i = 0; i < imgList.length; i++) {
        let trg = $(imgList[i]).find(".phLanImageListItemImg");
        $(".phLabEditImageList").append(
          "" +
            "<div class='phLabEditeImageListThumb'><input type='checkbox'>" +
            "<div id='" +
            $(trg).attr("id") +
            "'>" +
            "<div class='phLabEditImageListImage'><img class='' src='" +
            $(trg).find("img").attr("src") +
            "' alt='" +
            $(trg).find("img").attr("alt") +
            "'></div>" +
            "<div class='phLabEditImageListCrops'></div>" +
            "</div></div>"
        );
      }
      plCheckImageCropList();
    }

    function plChangeCrop(elm, callBack = function () {}) {
      if ($(elm).attr("id") !== plSelCrop.sizeId) plFabricSaveImg();

      let findFlag = false;
      let findIndex = plCrops.findIndex(
        (item) =>
          item.sizeId === $(elm).attr("id") && item.imageId === plSelImg.id
      );
      if (findIndex !== -1)
        // if (plCrops[findIndex].imageId === plSelImg.id)
        findFlag = true;

      let count = parseInt($(elm).find(".phLabEditSizeCountValue").html());
      if (!findFlag && count > 0) {
        let selSize = plSizes.find((item) => item.id === $(elm).attr("id"));
        let crop = {
          id: "crop" + plCropId++,
          imageId: plSelImg.id,
          sizeId: selSize.id,
          size: selSize.size,
          price: selSize.price,
          src: "",
          type: selSize.type,
          printType: selSize.printType,
          count: count,
          state: "temp",
        };
        plCrops.push(crop);
        plSelCrop = crop;

        plUpdateEditor(function () {
          callBack();
        });
      } else if (findFlag && count === 0) {
        plCrops.splice(findIndex, 1);
        plSelCrop = "";

        plUpdateEditor(function () {
          callBack();
        });
      } else if (findFlag && count > 0) {
        plCrops[findIndex].count = count;
        if ($(elm).attr("id") !== plSelCrop.sizeId) {
          plSelCrop = plCrops[findIndex];
          plUpdateEditor(function () {
            callBack();
          });
        } else {
          plCheckImageCropList();
        }
      }
    }

    function plFabricSaveImg() {
      if (plSelCrop !== "") {
        let imageRatio = plSelImg.width / plSelImg.height;
        let canvasRatio = fabricCanvas.width / fabricCanvas.height;
        let zoomVal = 1;

        if (imageRatio > canvasRatio)
          zoomVal = plSelImg.height / fabricCanvas.height;
        else zoomVal = plSelImg.width / fabricCanvas.width;

        zoomVal = zoomVal / plZoomCount;
        let src = fabricCanvas.toDataURL({
          format: "jpeg",
          multiplier: zoomVal,
        });
        let index = plCrops.findIndex((item) => item.id === plSelCrop.id);
        plCrops[index].src = src;
      }
    }

    function plUpdateEditor(callBack = function () {}) {
      $(".phLabEditCon").animate(
        {
          scrollTop: 0,
        },
        100
      );

      if (plSelCrop === "") {
        plResetOptions();
        plNoSizeSelect();
        plCheckImageCropList();
      } else {
        plChangeCropImage(function () {
          $(".phLabNoSize").hide();
          $(".phLabEditAreaCntTitle").html("Crop");
          $(".phLabEditAreaTitleType").html(plSelCrop.type);
          if (plSelCrop.printType !== "")
            $(".phLabEditAreaTitleTypeSub").html(
              "(" + plSelCrop.printType + ")"
            );
          else $(".phLabEditAreaTitleTypeSub").html("");
          $(".phLabEditAreaTitleSize").html(plGetSize(plSelCrop.size));
          $(".phLabCanvasCon").show();
          $(".phLabEditAreaTitle").show();
          $(".phLabEditAreaCntZoom").show();
          plApllyToSync();
          let ctnBtn = $(".phLabEditAreaCntBtn").children();
          $(ctnBtn[4]).show();
          $(ctnBtn[5]).show();
          $(ctnBtn[6]).show();
          plShowTour(2);
          callBack();
        });
      }
    }

    function plRemoveCrop(elm) {
      if (!confirm("Do you really want to delete this crop?")) return;
      let id = $(elm).attr("id");
      plCrops.splice(
        plCrops.findIndex((item) => item.id === id),
        1
      );
      $(elm).parent().remove();
      plSetTotalPrice();
      if ($(".phLabRightCrops").children().length === 0) {
        plCheckAllCropList();
      }
    }

    function plRemoveImageCrop(elm) {
      if (!confirm("Do you really want to delete this crop?")) return;
      let id = $(elm).attr("id");
      plCrops.splice(
        plCrops.findIndex((item) => item.id === id),
        1
      );
      $(elm).parent().remove();
      plUpdateSizeCounts();
      plCheckImageCropList();
    }

    function plRemoveImageFromList(item) {
      if (
        !confirm(
          "Do you really want to delete this images?" +
            "\n[Warning] Crops will be delete too."
        )
      )
        return;
      let imageId = $(item).find(".phLanImageListItemImg").attr("id");
      let delList = plCrops.filter((item) => item.imageId === imageId);
      for (let i = 0; i < delList.length; i++)
        plCrops.splice(
          plCrops.findIndex((item) => item.id === delList[i].id),
          1
        );

      $(item).remove();

      plCheckImageListVisibility();
      plCheckAllCropList();
    }

    function plAddToQueue() {
      plFabricSaveImg();
      let tempList = plCrops.filter((item) => item.state === "temp");
      for (let i = 0; i < tempList.length; i++) tempList[i].state = "ok";
    }

    function plCancelQueue() {
      let tempList = plCrops.filter((item) => item.state === "temp");
      for (let i = 0; i < tempList.length; i++)
        plCrops.splice(
          plCrops.findIndex((item) => item.id === tempList.id),
          1
        );
    }

    function plCheckAllCropList() {
      if (plCrops.length === 0) {
        $(".phLabRight").hide();
        $(".phLabLeft").removeClass("phLabLeftSide");
        $(".phLabCheckOut").hide();
      } else {
        $(".phLabRightCrops").html("");
        for (let i = 0; i < plCrops.length; i++) {
          $(".phLabRightCrops").append(
            "" +
              '<div class="phLabRightCrop">' +
              '<img src="' +
              $(".phLab-imageDir").html() +
              '/tick.png" alt="tick" class="phLabRightCropTick" >' +
              '<div class="phLabRightCropImg">' +
              '<img src="' +
              plCrops[i].src +
              '" alt="" class="phLabCenter">' +
              "</div>" +
              '<div class="phLabEditCropInfo">' +
              '<div class="phLabCropInfoSize">' +
              plGetSize(plCrops[i].size) +
              "</div>" +
              '<div class="phLabCropInfoType">' +
              plCrops[i].type +
              "</div>" +
              // '<div class="phLabCropInfoPrintType">' + plCrops[i].printType + '</div>' +
              '<div class="phLabCropInfoPrintPrice">$' +
              plCrops[i].price +
              " × " +
              plCrops[i].count +
              "</div>" +
              "</div>" +
              '<div class="phLabCropRemove" id="' +
              plCrops[i].id +
              '">remove</div>' +
              "</div>"
          );
        }
        $(".phLabRight").removeClass("phLabHide");
        $(".phLabLeft").addClass("phLabLeftSide");
        plSetTotalPrice();
        $(".phLabCheckOut").show();
      }
    }

    function plCheckImageCropList() {
      $(".phLabImageCropList").hide();
      // let imgCrops = plCrops.filter(item => item.imageId === plSelImg.id);
      let imgCrops = plCrops;
      $(".phLabEditImageList").find(".phLabEditImageListCrops").html("");
      if (imgCrops.length > 0) {
        let counter = 0;
        for (let i = 0; i < imgCrops.length; i++) {
          if (imgCrops[i].src === "") continue;
          counter++;
          let imagePos = $(".phLabEditImageList")
            .find("#" + imgCrops[i].imageId)
            .find(".phLabEditImageListCrops");
          $(imagePos).append(
            "" +
              '<div class="phLabEditImageListCrop">' +
              '<div class="phLabEditImageListCropInfoType">' +
              imgCrops[i].type +
              "</div>" +
              '<div class="phLabEditImageListCropInfoSize">' +
              plGetSize(imgCrops[i].size) +
              " × " +
              imgCrops[i].count +
              "</div>" +
              // '<div class="phLabCropInfoPrintType">' + imgCrops[i].printType + '</div>' +
              // '<div class="phLabEditImageListCropInfoPrintPrice">$' + imgCrops[i].price +  '</div>' +
              "</div>"
          );
        }
        if (counter > 0) {
          // $(".phLabImageCropList").show();
          // $(".phLabEditCancel2Con").show();
        }
      } else {
        // $(".phLabEditCancel2Con").hide();
      }
    }

    function plSetTotalPrice() {
      let totalPrice = 0;
      for (let i = 0; i < plCrops.length; i++) {
        totalPrice += plCrops[i].count * plCrops[i].price;
      }
      totalPrice = totalPrice.toFixed(2);
      $("#phLabCheckOutTotal").html(totalPrice);
    }

    function plGetTotalPrice() {
      let totalPrice = 0;
      for (let i = 0; i < plCrops.length; i++) {
        totalPrice += plCrops[i].count * plCrops[i].price;
      }
      totalPrice = totalPrice.toFixed(2);
      return totalPrice;
    }

    function plFabricCheckSize(obj, callBack) {
      if (Math.max(obj.width, obj.height) > 2048) {
        $("#phLabEditLoading").show();
        let ZoomPrev = $("#phLabEditAreaCntZoom").val();
        let TopPrev = plGetTop(obj);
        let LeftPrev = plGetLeft(obj);
        let scale = 2048 / Math.max(obj.width, obj.height);
        let resizeImg = new Image();
        resizeImg.crossOrigin = 'anonymous';
        resizeImg.src = plSelImg.src;
        resizeImg.onload = function () {
          let width = (resizeImg.width *= scale);
          let height = (resizeImg.height *= scale);

          let resizeCanvas = document.createElement("canvas");
          resizeCanvas.width = width;
          resizeCanvas.height = height;
          var resizeCanvasCtx = resizeCanvas.getContext("2d");
          resizeCanvasCtx.drawImage(resizeImg, 0, 0, width, height);
          resizeImg.src = resizeCanvas.toDataURL("image/jpeg");

          resizeImg.onload = function () {
            $("#phLabEditLoading").show();
            fabricCanvas.remove(fabricCanvas._objects[0]);
            fabricCanvas.renderAll();

            let imgInstance = new fabric.Image(resizeImg, {
              left: 0,
              top: 0,
              opacity: 1,
              hasRotatingPoint: false,
              transparentCorners: false,
              hasControls: false,
              centeredRotation: true,
            });
            fabricCanvas.add(imgInstance);
            plFabricFitImage();
            $("#phLabEditAreaCntZoom").val(ZoomPrev);
            plFabricZoom(ZoomPrev);
            plSetTop(fabricCanvas._objects[0], TopPrev);
            plSetLeft(fabricCanvas._objects[0], LeftPrev);
            fabricCanvas.renderAll();
            callBack();
            $("#phLabEditLoading").hide();
          };
        };
      } else callBack();
    }

    function plFabricSetRangeFilter(input) {
      let val = $(input).val();
      $(input)
        .parent()
        .find(".phLabEditAreaCntRangeCount")
        .html(Math.round(val * 100));
      plFabricCheckSize(fabricCanvas._objects[0], function () {
        let type = $(input).attr("id");
        let index = $(input).attr("data-index");
        let obj = fabricCanvas._objects[0];
        obj.filters[index] = new fabric.Image.filters[type]({
          [type.toLowerCase()]: val,
        });

        obj.applyFilters(obj.filters, true);
        fabricCanvas.renderAll();

        plCanvasMargin();
      });
    }

    function plFabricSetFilter(input) {
      if ($(input).hasClass("phLabEditAreaCntFilterActive")) return;

      plFabricCheckSize(fabricCanvas._objects[0], function () {
        let obj = fabricCanvas._objects[0];
        let index = $(input).attr("data-index");
        let type = $(input).attr("id");

        if (type === "Normal") obj.filters[index] = "";
        else obj.filters[index] = new fabric.Image.filters[type]();

        obj.applyFilters();
        fabricCanvas.renderAll();

        plCanvasMargin();

        $(input)
          .parent()
          .find(".phLabEditAreaCntFilterActive")
          .removeClass("phLabEditAreaCntFilterActive");
        $(input).addClass("phLabEditAreaCntFilterActive");
      });
    }

    function plOpenFilterMenu() {
      $(".phLabEditAreaCntRanges").hide();
      if ($(".phLabEditAreaCntFilters").is(":visible"))
        $(".phLabEditAreaCntFilters").hide();
      else $(".phLabEditAreaCntFilters").show();
    }

    function plResetOptions() {
      $(".phLabEditAreaCntRanges").hide();
      $(".phLabEditAreaCntFilters").hide();
      plApllyToSync();
      $(".phLabEditAreaCntFilters")
        .find(".phLabEditAreaCntFilterActive")
        .removeClass("phLabEditAreaCntFilterActive");
      $(".phLabEditAreaCntFilters")
        .children()
        .first()
        .addClass("phLabEditAreaCntFilterActive");
      $(".phLabEditAreaCntRanges").find("input[type=range]").val(0);
      $(".phLabCanvasCon").children(".phLabCanvasMargin").hide();
      $(".phLabCanvasCon").removeClass("phLabCanvasConHasMargin");
    }

    function plOpenAdjustMenu() {
      $(".phLabEditAreaCntFilters").hide();
      if ($(".phLabEditAreaCntRanges").is(":visible"))
        $(".phLabEditAreaCntRanges").hide();
      else $(".phLabEditAreaCntRanges").show();
    }

    function plCheckOut() {
      let dataList = [];
      let categoryList = [];

      var systemName = "PhotoPrints";
      if($(".phLabEditTypes").find(".phLabEditTypeActive").attr("id") == "canvas")
      {
        systemName = "CanvasPrints"
      }
      if (isMetal) systemName = "MetalPrints";
      if (isFoam) systemName = "FoamPrints";
      
      for (let i = 0; i < plCrops.length; i++) {
        dataList.push(plCrops[i].src);
        let ss = plCrops[i].size.split("-");
        categoryList.push(
          systemName + "-" + ss[0] + ":" + ss[1] + "-" + plCrops[i].count
        );
      }
      

      canadaUploader(
        dataList,
        null,
        "jpeg",
        function (response) {
          let desc = "";
          let counts = "";
          for (let i = 0; i < plCrops.length; i++) {
            desc += plGetSize(plCrops[i].size) + " " + plCrops[i].type;
            if (plCrops[i].printType !== "")
              desc += " (" + plCrops[i].printType + ")";
            desc += "\n";

            counts += plCrops[i].count + "\n";
          }

          // $("#input_10_4").val(response);
          // $("#input_10_5").val(desc);
          // $("#input_10_7").val(counts);
          // $("#input_10_1").val(plGetTotalPrice());
          // $("#input_10_2").val(plGetTotalPrice());

          // $("#gform_submit_button_10").click();

          var productName = "Photo Prints";

          if (isMetal) productName = "Metal Prints";
          if (isFoam) productName = "Foam Prints";
          
          var formData = new FormData();

          formData.append("order_url", response);
          formData.append("order_size", desc);
          formData.append("order_quntity", counts);
          formData.append("price", plGetTotalPrice());
          formData.append("title", productName);
          formData.append("order_type", productName);
          formData.append("product_type","PhotoPrints");
          formData.append("image_url", response.split("\n")[0].trim());

          $.ajax({
            url: "https://canadaphotolab.com/wp-content/themes/printspace/shopify/create_draft_order.php",
            method: "POST",
            data: formData,
            contentType: false,
            processData: false,
            dataType: "json",
            success: function (response) {
              if (response.success) {
                window.location.href = response.url;
              } else {
                alert("Error: " + (response.message || "Something went wrong"));
                console.log(response);
              }
            },
            error: function (xhr, status, error) {
              alert(
                "AJAX error: " + xhr.responseText + " " + status + " " + error
              );
              console.log(xhr.responseText);
            },
          });
        },
        true,
        categoryList
      );
    }

    function plOriUpdate(ori = "auto") {
      if (ori === "auto") {
        var ratio = plSelImg.width / plSelImg.height;
        if (ratio <= 1.1 && ratio >= 0.9) ori = "Square";
        else if (ratio < 0.9) ori = "Portrait";
        else if (ratio > 1.1 && ratio < 2) ori = "Landscape";
        else if (ratio >= 2) ori = "Panorama";
      }
      $(".phLabEditAreaCnt")
        .find(".phLabEditAreaCntBtnActive")
        .removeClass("phLabEditAreaCntBtnActive");
      $("#phLabEdit" + ori).addClass("phLabEditAreaCntBtnActive");

      plSetSizes(ori);
    }

    function plGetSizeOri(size) {
      size = size.split("-");
      let ori = "";
      let ratio = size[0] / size[1];
      if (ratio === 1) ori = "Square";
      else if (ratio < 1) ori = "Portrait";
      else if (ratio > 1 && ratio < 2) ori = "Landscape";
      else if (ratio >= 2) ori = "Panorama";
      return ori;
    }

    function plSelectClear() {
      $(".phLabEditImageList")
        .find("input[type=checkbox]")
        .prop("checked", false);
    }

    function plSelectAll() {
      $(".phLabEditImageList")
        .find("input[type=checkbox]")
        .prop("checked", true);
      if ($(window).width() <= 425) {
        selectAllApplyTo = true;
        $(".phLabEditImageList").children().first().find(">div>div").click();
      }
    }

    function plApplyTo() {
      // if(!confirm("Are You Sure?"))
      //     return;

      plFabricSaveImg();

      let imagelist = $(".phLabEditImageList").find(
        "input[type=checkbox]:checked"
      );
      if (imagelist.length === 0) {
        alert("No Image Selected.");
        return;
      }

      let mainImageId = plSelImg.id;
      let cropList = plCrops.filter((item) => item.imageId === mainImageId);

      $("#phLabEditLoading").show();

      imageCounter = 0;
      cropCounter = 0;

      addCrop();

      function addCrop() {
        let imageId = $(imagelist[imageCounter]).next().attr("id");

        if (imageCounter === imagelist.length) {
          if (cropCounter === cropList.length - 1) {
            $("#phLabEditLoading").hide();
            return;
          }
          imageCounter = 0;
          cropCounter++;
          addCrop();
          return;
        }

        if (mainImageId === imageId) {
          imageCounter++;
          addCrop();
          return;
        }

        let cropId = cropList[cropCounter].sizeId;
        let cropSize = plSizes.filter((item) => item.id === cropId)[0].size;
        cropSize = cropSize.split("-");

        let image = $(imagelist[imageCounter]).next().find("img").get(0);
        let imageRatio = image.naturalWidth / image.naturalHeight;

        let tempCropId = -1;

        let type = $(".phLabEditTypes").find(".phLabEditTypeActive").attr("id");
        if (type === "photoPaper") type = "Photo Paper";
        else if (type === "canvas") type = "Canvas";
        else if (type === "metal") type = "Metal";

        if (
          (getOri(cropId) === "Landscape" || getOri(cropId) === "Portrait") &&
          imageRatio <= 1.1 &&
          imageRatio >= 0.9
        ) {
          let max = Math.max(cropSize[0], cropSize[1]);
          let min = Math.min(cropSize[0], cropSize[1]);

          let temp = plSizes.filter(
            (item) => item.size === max + "-" + max && item.type === type
          );
          if (temp.length === 0)
            temp = plSizes.filter(
              (item) => item.size === min + "-" + min && item.type === type
            );

          if (temp.length > 0) tempCropId = temp[0].id;
        } else if (
          (getOri(cropId) === "Landscape" && imageRatio < 1.1) ||
          (getOri(cropId) === "Portrait" && imageRatio > 0.9)
        ) {
          let temp = plSizes.filter(
            (item) =>
              item.size === cropSize[1] + "-" + cropSize[0] &&
              item.type === type
          );
          if (temp.length > 0) tempCropId = temp[0].id;
        }

        if (tempCropId !== -1) cropId = tempCropId;

        if (
          plCrops.filter(
            (item) => item.imageId === imageId && item.sizeId === cropId
          ).length > 0
        ) {
          imageCounter++;
          addCrop();
          return;
        }

        plChangeEditorImage($(imagelist[imageCounter]).next(), getOri(cropId));

        setTimeout(function () {
          $("#" + cropId)
            .find(".phLabEditSizeCountValue")
            .html(cropList[cropCounter].count);
          plChangeCrop($("#" + cropId), function () {
            imageCounter++;
            addCrop();
          });
        }, 1000);
      }

      function getOri(cropId) {
        let size = plSizes.filter((item) => item.id === cropId)[0].size;
        size = size.split("-");
        let ratio = size[0] / size[1];
        if (ratio <= 1.1 && ratio >= 0.9) ori = "Square";
        else if (ratio < 0.9) ori = "Portrait";
        else if (ratio > 1.1 && ratio < 2) ori = "Landscape";
        else if (ratio >= 2) ori = "Panorama";
        return ori;
      }
    }

    function plApllyToSync() {
      if (plCrops.filter((item) => item.imageId === plSelImg.id).length > 0) {
        if ($(window).width() <= 425) {
          $(".phLabApplyTo2").show();
        } else {
          $(".phLabApplyTo").show();
        }
      } else {
        $(".phLabApplyTo").hide();
        $(".phLabApplyTo2").hide();
      }
    }

    // Actions

    $(".phLabApplyTo,.phLabApplyTo2").click(function () {
      plApplyTo();
    });

    $(".phLabSelectAll").click(function () {
      plSelectAll();
    });

    $(".phLabClearSelection").click(function () {
      plSelectClear();
    });

    $(".phLabEditMainLeftArrowCon").click(function () {
      $(".phLabEditMainLeft").slideToggle();
    });

    $("#phLabEditLandscape").click(function () {
      plNoSizeSelect("Landscape");
    });
    $("#phLabEditPortrait").click(function () {
      plNoSizeSelect("Portrait");
    });
    $("#phLabEditSquare").click(function () {
      plNoSizeSelect("Square");
    });
    $("#phLabEditPanorama").click(function () {
      plNoSizeSelect("Panorama");
    });

    $(".phLabCheckOutBtn").click(function () {
      plCheckOut();
    });

    $(".phLabUploadArea,.phLabEditUploadArea,#photoStartUpload,.sh-tab-item-active .sh-twi-2-tab-item-media p").click(
      function () {
        $("#phLabAddImageByClick").get(0).click();
      }
    );

    $("#phLabAddImageByClick").change(function (e) {
      $("#phLabLoading").show();
      plAddImageToList(e.target.files);
    });

    $(".phLabImageListItems").on("click", " .phLabImageRemove", function () {
      plRemoveImageFromList($(this).parent());
    });

    $(".phLabEditRight").on(
      "click",
      ".phLabEditSizeCountPlus,.phLabEditSizeCountMines",
      function () {
        plChangeCount($(this));
        plChangeCrop($(this).parent().parent());
      }
    );

    $(".phLabEditTypes").on("click", " .phLabEditType", function () {
      plChangeEditTab($(this));
    });

    $("#phLabPhotoPaperTypes").change(function () {
      plCheckSelectState();
    });

    $(".phLabEditCancel,.phLabEditCancel2Con").click(function () {
      plCancelQueue();
      plCloseEditor();
    });

    $(".phLabEditAddToQueue").click(function () {
      plAddToQueue();
      plCloseEditor();
    });

    $(".phLabEditAddToQueue2").click(function () {
      plAddToQueue();
      plCloseEditor();
    });

    $(".phLabImageListItems").on(
      "click",
      " .phLanImageListItemImg",
      function () {
        plOpenEditor($(this));
      }
    );

    $(".phLabEditImageList").on("click", ">div>div", function () {
      plChangeEditorImage($(this));

      if ($(window).width() <= 650) {
        $(".phLabEditRight").show();
        $(".phLabEditRight").scrollTop(0);
      }
    });

    $(".phLabEditRightDone").click(function () {
      $(".phLabEditRight").hide();
      if (selectAllApplyTo) {
        selectAllApplyTo = false;
        plApplyTo();
      }
    });

    $(window).resize(function () {
      if ($(window).width() > 650) $(".phLabEditRight").show();
      plApllyToSync();
    });

    $(".phLabEditSizes").on("click", " .phLabEditSizeDesc", function () {
      plChangeCount($(this).parent());
      plChangeCrop($(this).parent());
    });

    $(".phLabEditSizes").on("click", " .phLabEditSizePrice", function () {
      plChangeCount($(this).parent());
      plChangeCrop($(this).parent());
    });

    fabricCanvas.on("object:moving", function (options) {
      plFabricPreventMovingOverflow(options);
      let obj = fabricCanvas._objects[0];
    });

    $(".phLabEditAreaCnt").on("input", "#phLabEditAreaCntZoom", function () {
      plFabricZoom($(this).val());
    });

    // $("#phLabEditRotate").click(function () {
    //     plFabricRotate();
    // });

    $("#phLabEditFilters").click(function () {
      plOpenFilterMenu();
    });

    $("#phLabEditAdjust").click(function () {
      plOpenAdjustMenu();
    });

    $(".phLabRightCrops").on("click", " .phLabCropRemove", function () {
      plRemoveCrop($(this));
    });

    $(".phLabImageCrops").on("click", " .phLabCropRemove", function () {
      plRemoveImageCrop($(this));
    });

    $(".phLabEditAreaCntRanges").on("input", "input[type=range]", function () {
      plFabricSetRangeFilter($(this));
    });

    $(".phLabEditAreaCntRanges").on(
      "click",
      " .phLabEditAreaCntRangeReset",
      function () {
        let elm = $(this)
          .parents(".phLabEditAreaCntRange")
          .find("input[type=range]");
        elm.val(0);
        plFabricSetRangeFilter(elm);
      }
    );

    $(".phLabEditAreaCntFilters").on(
      "click",
      " .phLabEditAreaCntFilter",
      function () {
        plFabricSetFilter($(this));
      }
    );

    $(".phLabEditAreaCnt").on("change", "#phLabEditAreaCntZoom", function () {
      plCanvasMargin();
    });
    fabricCanvas.on("object:moved", function () {
      plCanvasMargin();
    });

    // drag and drop

    $(".phLabUploadArea,.phLabEditUploadArea").droppable();
    $(".phLabUploadArea,.phLabEditUploadArea").on("dragover", function (e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).addClass("phLabUploadAreaDrag");
    });
    $(".phLabUploadArea,.phLabEditUploadArea").on("dragenter", function (e) {
      e.preventDefault();
      e.stopPropagation();
    });
    $(".phLabUploadArea,.phLabEditUploadArea").on("dragleave", function (e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).removeClass("phLabUploadAreaDrag");
    });
    $(".phLabUploadArea,.phLabEditUploadArea").on("drop", function (e) {
      $(this).removeClass("phLabUploadAreaDrag");
      if (
        e.originalEvent.dataTransfer &&
        e.originalEvent.dataTransfer.files.length
      ) {
        e.preventDefault();
        e.stopPropagation();
        plAddImageToList(e.originalEvent.dataTransfer.files);
      }
    });
  }
});
